<template>
    <el-row :gutter="20" class="pd20">
        <h1 class="title">非腾讯系游戏账号交易流程</h1>
        <div class="el-line-h"></div>
        
        <div class="subtitle"><i class="el-icon-star-on"></i>发布账号商品(卖家)</div>
        <div class="subcontent">签署账号转让协议，审核通过后在商品列表页显示</div>

        <div class="subtitle"><i class="el-icon-star-on"></i>账号信息审核(客服)</div>
        <div class="subcontent">审核账号安全信息，核实账号是否真实存在(非登录游戏)</div>

        <div class="subtitle"><i class="el-icon-star-on"></i>截图验号(买家/客服)</div>
        <div class="subcontent">客服上号截图提供给买家确认</div>

        <div class="subtitle"><i class="el-icon-star-on"></i>确认购买(买家)</div>
        <div class="subcontent">买家查看截图无问题确认购买后，非卖方原因不可单方面取消交易</div>

        <div class="subtitle"><i class="el-icon-star-on"></i>卖家资料审核(卖家&客服)</div>
        <div class="subcontent">终身包赔订单需提供本人相关信息(身份证正反面)，高价值商品需额外提供上半身自拍照，可打水印，</div>

        <div class="subtitle"><i class="el-icon-star-on"></i>账号资料换绑(卖家&客服&买家)</div>
        <div class="subcontent">客服将账号绑定换绑给买家，未绑定邮箱30分钟换绑成功，绑定邮箱24小时换绑成功</div>

        <div class="subtitle"><i class="el-icon-star-on"></i>账号交易完成(买家&客服)</div>
        <div class="subcontent">客服发送账号给买家，买家30分钟内确认，订单交易完成</div>

        <div class="subtitle"><i class="el-icon-star-on"></i>签署服务协议(卖家&买家)</div>
        <div class="subcontent">卖家签署电子协议，卖家承诺账号安全永不找回，约定找回后责任归属及承担后果</div>

        <div class="subtitle"><i class="el-icon-star-on"></i>卖家资金到账(客服)</div>
        <div class="subcontent">卖家签署协议后，系统打款给卖家</div>

    </el-row>

</template>

<script>


export default {
    name: "guide1",
    data() {
        return {

        };
    },
    components: {

    },
    computed: {

    },
    created() {

    },
    activated() {

    },
    deactivated() {

    },
    methods: {


    }
};
</script>


<style scoped>
.el-row {
    margin-bottom: 20px;
}

.title {
    font-size: 32px;
    width: 100%;
    text-align: center;
    line-height: 50px;
    font-weight: 400;
    color: #ff8800;
}

.subtitle {
    font-size: 20px;
    line-height: 40px;
    font-weight: 400;

}

.subcontent {
    font-size: 18px;
    line-height: 30px;
    color: rgb(124, 124, 124);
    padding-left: 20px;
    margin-bottom: 30px;
}

.el-icon-star-on
{
    color: #ffa01b;
}
</style>
